import React, { useState, useEffect } from 'react';
import StandingsFish from './StandingsFish'

const StandingsFishScores = ({tournament_event_type, submissions, measurement_type, maxFish,user_information,length_measurement_symbol,weight_measurement_symbol,hide_fish_records, colSpan = 1}) => {
  const [setpereventperday, setPerEventPerDay] = useState('');
 //Naveen 30/Jan/2024::TP-349 added condition do not show fish_caught_day tournament_event_type = 'per_event' show it for 'per_day' 
  // Similar to componentDidMount and componentDidUpdate:  
  useEffect(() => {    // Update the document title using the browser API   
    if(tournament_event_type!= 1 ){
      setPerEventPerDay(`per_event`)
    }else{
      setPerEventPerDay(`per_day`)
    }
  });

  maxFish = maxFish ? maxFish : 0 

  let fish = []

  console.log('hide_fish_records value passed in StandingsFishScores::', hide_fish_records);
  console.log('tournament_event_type value passed in StandingsFishScores::', tournament_event_type);
  

  if(submissions) {
    
     /* Following submissions if-condition logic will work for regular,custom,multi day tournaments */
    if( submissions.length <= maxFish ){
      //Naveen 04/Jan/2024::TP-349 added condition for tourney type-19-Day. value passed for fish_caught_day in StandingsFish component is used in StandingsFish.js to call in getSubmissionFishCaught 
      
      if(measurement_type === 'length'){
          //Naveen 30/Jan/2024::TP-349 added condition do not show fish_caught_day tournament_event_type = 'per_event' show it for 'per_day' tournament_event_type={`per_event`}
        fish = submissions.map((fish, index) => <StandingsFish tournament_event_type={setpereventperday} fish_caught_day={fish.day} score={fish.fish_length} type={fish.fish_type} photo={fish.submission_id} status={fish.status} measurement_type = {measurement_type} user_information={user_information} formatted_date_taken = {fish.formatted_date_taken} formatted_date_submitted = {fish.formatted_date_submitted} length_measurement_symbol = {length_measurement_symbol} weight_measurement_symbol = {weight_measurement_symbol} hide_fish_records = {hide_fish_records} key={`standing${index}`} />)
        if(maxFish - submissions.length > 0) {
          if(hide_fish_records && hide_fish_records == '1'){
            fish.push(<td style={{opacity:'0'}} colSpan={maxFish - submissions.length}><div className="standings-fish-score"></div></td>)
          }else{
            fish.push(<td colSpan={maxFish - submissions.length}><div className="standings-fish-score"></div></td>)
          }
          
        }else{

        }
      }else{
         //Naveen 30/Jan/2024::TP-349 added condition do not show fish_caught_day tournament_event_type = 'per_event' show it for 'per_day' tournament_event_type={`per_event`}
        fish = submissions.map((fish, index) => <StandingsFish tournament_event_type={setpereventperday} fish_caught_day={fish.day} score={fish.fish_weight} type={fish.fish_type} photo={fish.submission_id} status={fish.status} measurement_type = {measurement_type} user_information={user_information} formatted_date_taken = {fish.formatted_date_taken} formatted_date_submitted = {fish.formatted_date_submitted} length_measurement_symbol = {length_measurement_symbol} weight_measurement_symbol = {weight_measurement_symbol} hide_fish_records = {hide_fish_records} key={`standing${index}`} />)
        if(maxFish - submissions.length > 0) {
          if(hide_fish_records && hide_fish_records == '1'){
            fish.push(<td style={{opacity:'0'}} colSpan={maxFish - submissions.length}><div className="standings-fish-score"></div></td>)
          }else{
            fish.push(<td colSpan={maxFish - submissions.length}><div className="standings-fish-score"></div></td>)  
          }
          
        }else{

        }
      }
     

    }

     /* Following submissions if-condition logic will work for xlf, xlf-APEX type tourneys */
    if( submissions.length > maxFish ){
      if(measurement_type === 'length'){
        //Naveen 30/Jan/2024::TP-349 Added condition do not show fish_caught_day tournament_event_type = 'per_event' show it for 'per_day' tournament_event_type={`per_event`}
        fish =  submissions.slice(0,maxFish).map((fish, index) => 
          <StandingsFish tournament_event_type={setpereventperday} fish_caught_day={fish.day} score={fish.fish_length} type={fish.fish_type} photo={fish.submission_id} status={fish.status} measurement_type = {measurement_type} user_information={user_information} formatted_date_taken = {fish.formatted_date_taken} formatted_date_submitted = {fish.formatted_date_submitted} length_measurement_symbol = {length_measurement_symbol} weight_measurement_symbol = {weight_measurement_symbol} hide_fish_records = {hide_fish_records} key={`standing${index}`} />
        );
      }else{
        //Naveen 30/Jan/2024::TP-349 added condition do not show fish_caught_day tournament_event_type = 'per_event' show it for 'per_day' tournament_event_type={`per_event`}
        fish =  submissions.slice(0,maxFish).map((fish, index) => 
          <StandingsFish tournament_event_type={setpereventperday} fish_caught_day={fish.day} score={fish.fish_weight} type={fish.fish_type} photo={fish.submission_id} status={fish.status} measurement_type = {measurement_type} user_information={user_information} formatted_date_taken = {fish.formatted_date_taken} formatted_date_submitted = {fish.formatted_date_submitted} length_measurement_symbol = {length_measurement_symbol} weight_measurement_symbol = {weight_measurement_symbol} hide_fish_records = {hide_fish_records} key={`standing${index}`} />
        );

      }
     
    }else{

    }

  } else {

    if(hide_fish_records && hide_fish_records == '1'){
      fish.push(<td style={{opacity:'0'}} colSpan={maxFish}><div className="standings-fish-score"></div></td>)
    }else{
      fish.push(<td colSpan={maxFish}><div className="standings-fish-score"></div></td>)
    }
    
  }

  return (
    <>

    {fish}

    </>
  )
}

export default StandingsFishScores